<template>
  <div>
    <!-- 搜索部分 -->

    <!-- 主体部分  -->
    <div class="clearfix" style="position: relative">
      <!-- 菜单部分 -->
      <el-card class="clearfix ele-card menu-area">
        <!--  导出 新增  -->
        <div style="display:inline-block">
          <el-button type="success" size="mini" @click="editCoupons(0)">新增</el-button>
        </div>
        <!-- 页码 -->
        <div class="fright">
          <el-pagination
            small
            v-if="total > 0"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="search.page"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="search.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-card>
      <!-- table部分 -->
      <el-table :data="tableData"
                border
                stripe
                ref="table"
                class="ele-table table-info-area">

        <el-table-column label="优惠券弹窗ID" align="center" width="200">
          <template slot-scope="scope">
            <p>{{scope.row.popId}}</p>
          </template>
        </el-table-column>

        <el-table-column label="图片(点击前后)" align="center"  width="200">
          <template slot-scope="scope">
            <image-component :image="scope.row.beforeImage" width="80"></image-component>
            <image-component :image="scope.row.afterImage" width="80"></image-component>
          </template>
        </el-table-column>

        <el-table-column label="关联优惠券" align="center">
          <template slot-scope="scope">
            <p>抽象券ID:<a :href="`/admin.php?method=novicegift.showDefinitionList&groupId=31`" target="_blank">{{scope.row.abstractId}}</a></p>
          </template>
        </el-table-column>

        <el-table-column label="开放时间" align="center" width="350">
          <template slot-scope="scope">
            <p>{{ scope.row.startTime }} ~ {{ scope.row.endTime }}</p>
            <p class="tag is-black" v-if="scope.row.status==0">未开始</p>
            <p class="tag is-success" v-if="scope.row.status==1">展示中</p>
            <p class="tag is-light" v-if="scope.row.status==2">已结束</p>
          </template>
        </el-table-column>

        <el-table-column label="领取张数/使用张数" align="center">
          <template slot-scope="scope">
            <p>{{(scope.row.getCount || scope.row.useCount) ? `${scope.row.getCount}/${scope.row.useCount}` : 0}}</p>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="center" width="100">
          <template slot-scope="scope">
            <p class="a-button">
              <a class="" @click="editCoupons(scope.row.popId,scope.row.status)">编辑</a>
            </p>
          </template>
        </el-table-column>

      </el-table>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        search: {
          page: 1,
          pageSize: 20
        },
        total: 0,
        tableData: [],
      };
    },
    mounted(){
      this.getCouponsList();
    },
    methods:{
      // 翻页
      handleCurrentChange(page) {
        if (this.search.page !== page) {
          this.search.page = page;
          this.getCouponsList();
          window.scrollTo(0, 0);
        }
      },
      // 改变页数
      handleSizeChange(pageSize) {
        this.search.pageSize = pageSize;
        this.getCouponsList();
        window.scrollTo(0, 0);
      },
      // 获取广告位列表
      getCouponsList() {
        let params = {
          page:this.search.page,
          pageSize:this.search.pageSize,
        }
         HttpRequest.get('/admin.php?method=miniprogram.getPopCouponList', params).then((response) => {
           this.tableData = response.data.list;
           this.total = parseInt(response.data.count);
         });
      },
      // 新增/编辑预告
      editCoupons(popId,status) {
        // 有id则路由传参
        if (popId != 0) {
          this.$router.push({
            name: 'editCouponsPop',
            query: {
              popId: popId,
              status: status
            }
          })
        } else {
          this.$router.push({
            name: 'editCouponsPop'
          })
        }
      },
    }
  };
</script>

<style lang="less" scoped>
  .dialogImg {
    text-align: center;
  }
  .control {
    margin-bottom: 0;
  }
  .tag{
    display: inline-block;
    align-items: center;
    color: #69707a;
    font-size: 12px;
    height: 24px;
    line-height: 24px;
    padding-left: 10px;
    padding-right: 10px;
    white-space: nowrap;
    border-radius: 12px;
  }
  .is-success{
    background-color: #97cd76;
    color: #fff;
  }
  .is-black{
    background-color: #464545;
    color: #fff;
  }
  .is-light{
    background-color: #f5f7fa;
    color: #69707a;
  }
</style>
